import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EntitySchemaService} from 'app/modules/core/services/entity-schema.service';
import {NotificationsService, ProjectService} from 'app/modules/core/services/index';
import {GuiZone, Project} from 'app/modules/core/types/api-v2/index';
import {GenericLinkedResource} from 'app/modules/core/types/base';
import {EntitySchemaType} from 'app/modules/core/utils/json-schema/entity-schema-to-json-schema';
import {GuiZoneService} from 'app/modules/project-details/services/index';
import {SelectItem} from 'primeng/primeng';
import {Observable} from 'rxjs/Observable';
import {isNullOrUndefined} from 'util';

/**
 * This component provides all methods and services to display a form to create a new GUI Zone for the current selected
 * Project.
 *
 */
@Component({
  templateUrl: 'create-gui-zone.component.html',
})
export class CreateGuiZoneComponent implements OnInit, OnDestroy {

  form: FormGroup;

  labels = {
    name: 'Name',
    shortName: 'Short Name',
    sortIndex: 'Sort Index',
    groupType: 'Group Type',
    zonePa: 'PA Zone',
    type: 'Type',
    parentGuiZone: 'Parent GUI Zone',
  };

  ZONE_GROUP = 'zoneGroup';

  guiZoneOptions: SelectItem[];
  typeOptions: SelectItem[];
  showGroupType: boolean = false;
  groupTypeOptions: SelectItem[];

  private project: Project;
  private modelSchema;

  constructor(
    private formBuilder: FormBuilder,
    private guiZoneService: GuiZoneService,
    private projectService: ProjectService,
    private notificationService: NotificationsService,
    private schemaService: EntitySchemaService,
  ) {
    this.modelSchema = this.schemaService.getForEntityName(EntitySchemaType['GuiZones']);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      name: this.formBuilder.control('', [Validators.required]),
      shortName: this.formBuilder.control('', [Validators.required]),
      sortIndex: this.formBuilder.control('', [Validators.required]),
      zonePa: this.formBuilder.control('', [Validators.required]),
      type: this.formBuilder.control('', [Validators.required]),
      group_type: this.formBuilder.control('', []),
      parent: this.formBuilder.control('', []),
    });
    this.projectService
      .getCurrent()
      .subscribe((project: Project) => {
        if (!isNullOrUndefined(project)) {
          this.project = project;
          const guiZones = this.projectService.extractGuiZonesFrom(this.project);
          this.updateGuiZoneOptions(guiZones);
        }
      });
    this.updateChoicesOptions(this.modelSchema.properties.type.choices);
    this.updateGroupTypeOptions(this.modelSchema.properties.group_type.choices);
  }

  ngOnDestroy() {
  }

  updateShowGroupType($event) {
    console.log('Event: ', $event);
    this.showGroupType = ($event.value === this.ZONE_GROUP);
    if (!this.showGroupType && this.form) {
      this.form.patchValue({group_type: null});
    }
  }

  /**
   * When submit a form a new GuiZone a GuiZone will be created and directly afterwards,
   * if required, assigned to a parent GuiZone
   */
  onSubmit() {
    const formValue = {
      project: this.project,
      ...this.form.value
    };
    console.log(formValue);
    const subscription = this.guiZoneService.create(formValue)
      .finally(() => subscription.unsubscribe())
      .subscribe((guiZone: GuiZone) => {
        this.handleCreateResult(guiZone);
      });
  }

  private handleCreateResult(guiZone: GuiZone) {
    this.notificationService.success('New Gui Zone created', `GUI Zone ${guiZone.name} was created.`);
    this.form.reset();
    this.projectService.refreshCurrent();

  }

  private updateChoicesOptions(typeChoices: string[]) {
    const items: SelectItem[] = [];
    typeChoices.forEach((name: string) => items.push({label: name, value: name}));
    this.typeOptions = items;
  }

  private updateGroupTypeOptions(groupTypeChoices: string[]) {
    const items: SelectItem[] = [];
    groupTypeChoices.forEach((name: string) => items.push({label: name, value: name}));
    this.groupTypeOptions = items;
  }

  private updateGuiZoneOptions(guiZones: GuiZone[]) {
    const items: SelectItem[] = [];
    items.push({label: '', value: null});
    guiZones.forEach((guiZone: GuiZone) => items.push({label: guiZone.name, value: guiZone}));
    this.guiZoneOptions = items;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/components/gui-zone/create-gui-zone/create-gui-zone.component.ts